import React from 'react'
import PropTypes from '../../utils/propTypes'

import classNames from 'classnames'

import { Card, CardBody, CardTitle, CardSubtitle, CardText } from 'reactstrap'
import Typography from '../Typography'

const Text2Widget = ({ bgColor, title, subtitle, text, text2, color, className, ...restProps }) => {
  const classes = classNames('cr-widget', className, {
    [`bg-${bgColor}`]: bgColor,
  })
  return (
    <Card body {...restProps} style={{ height: '100%' }}>
      <div className="d-flex justify-content-center">
        <CardText tag="div">
          <Typography className="mb-0">
            <strong>{title}</strong>
          </Typography>
        </CardText>
      </div>
      <div className="d-flex justify-content-center">
        <CardTitle>
          <strong style={{ color: color }}>{text}</strong>
        </CardTitle>
      </div>
      {text2 != undefined && (
        <div className="d-flex justify-content-center">
          <CardTitle>
            <strong>Average ${text2}</strong>
          </CardTitle>
        </div>
      )}
    </Card>
  )
}

Text2Widget.propTypes = {
  bgColor: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

Text2Widget.defaultProps = {
  bgColor: 'white',
}

export default Text2Widget
